import {Box, Image, Text} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import Autoplay from 'embla-carousel-autoplay';
import {useRef} from "@wordpress/element";

const _BannerSlider = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));


    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            {
                'new-arrivals' === component.slug &&
                <Text
                    fz="18px"
                    c={component?.customize_styles?.text_decoration?.color}
                    mx={component?.customize_styles?.text_decoration?.margin_x}
                    my={component?.customize_styles?.text_decoration?.margin_y}
                    px={component?.customize_styles?.text_decoration?.padding_x}
                    py={component?.customize_styles?.text_decoration?.padding_y}
                    bg={component?.customize_styles?.text_decoration?.background_color}
                    lh='1'
                    fw={700}
                >
                    {component?.customize_properties?.label}
                </Text>
            }

            <Carousel
                align="start"
                withControls={false}
                withIndicators
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}
                height={200}
            >
                {
                    component?.customize_properties?.items?.map((item, index) => (
                        <Carousel.Slide
                            key={item.image}
                            bg={component?.customize_styles?.box_decoration?.background_color}
                            mx={component?.customize_styles?.box_decoration?.margin_x}
                            my={component?.customize_styles?.box_decoration?.margin_y}
                            px={component?.customize_styles?.box_decoration?.padding_x}
                            py={component?.customize_styles?.box_decoration?.padding_y}
                            style={{
                                boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,

                            }}
                        >
                            <Image src={item?.image} fit="cover" h="100%" />
                        </Carousel.Slide>
                    ))
                }
            </Carousel>
        </Box>
    );
}

export default _BannerSlider;